<template>
  <router-view :key="route.fullPath" />
  <notifications group="success" position="top center">
    <template #body="{ item, close }">
      <div class="vue-notification-template success">
        <div v-text="item.text" />
        <a class="close" @click="close">Close</a>
      </div>
    </template>
  </notifications>
  <notifications group="error" position="top center">
    <template #body="{ item, close }">
      <div class="vue-notification-template error">
        <div v-text="item.text" />
        <a class="close" @click="close">Close</a>
      </div>
    </template>
  </notifications>
  <notifications />
  <FeedbackOverlay v-if="feedbackEnabled && accountStore.isLoggedIn && !accountStore.account.isScannerOnlyEnabled" :key="accountStore.userId || ''" />
</template>

<script lang="ts">
/* global __PAGE_FEEDBACK_ENABLED__ */
import { defineAsyncComponent, defineComponent, onBeforeMount } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { setupApp } from '@/services/Helpers'
import { useAccountStore } from '@/store/account'

const feedbackEnabled = __PAGE_FEEDBACK_ENABLED__ && (
  ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname) ||
  window.location.hostname === 'dev.pacsortonline.com'
)
// Compile-time flag lets the live build remove this import and the entire feature chunk.
const FeedbackOverlay = __PAGE_FEEDBACK_ENABLED__
  ? defineAsyncComponent(() => import('@/views/Components/Feedback/FeedbackOverlay.vue'))
  : undefined

export default defineComponent({
  name: 'LabelPortal',
  components: FeedbackOverlay ? { FeedbackOverlay } : {},
  setup() {
    const accountStore = useAccountStore()
    const route = useRoute()
    const router = useRouter()

    onBeforeMount(() => {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        if (window.location.pathname === '/faq') {
          return
        }
        router.push({ name: 'mobile.unsupported' })
      }
    })

    setInterval(() => {
      setupApp()
    }, 60000)

    return {
      accountStore,
      feedbackEnabled,
      route,
    }
  },
})
</script>
